// PocImage.jsx
import React, { useState, useEffect } from 'react';
import ImageModal from '../components/modal/ImageModal.js'; // 路徑依你實際放的位置調整

function PocImage2(props) {
  // 控制 modal 開關
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Device type: true = mobile / tablet / small screen, false = desktop
  const [isMobile, setIsMobile] = useState(false);
  const [deviceType, setDeviceType] = useState('Unknown');

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileUA = /android|iphone|ipad|ipod|windows phone/i.test(ua);
    const isSmallScreen = window.innerWidth < 1024;

    const mobile = isSmallScreen;
    setIsMobile(mobile);
    setDeviceType(mobile ? 'Mobile / Tablet' : 'Desktop');

    // For console testing
    console.log('UserAgent:', ua);
    console.log(
      'Detected device type:',
      mobile ? 'Mobile / Tablet' : 'Desktop'
    );
  }, []);

  // 這裡是你現在的 S3 圖片路徑
  // 之後如果要改成動態 (後端產生) 只要把這個換掉即可
  const imageUrl =
    'https://webapipmscms-prod.s3.ap-southeast-1.amazonaws.com/events/20251204_red_packet/RedPacket_d07.png';

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* 如果要先顯示一張直接在頁面上的圖片 */}
      <div style={{ marginBottom: '1rem', fontFamily: 'monospace' }}>
        <div>
          Detected device type: <strong>{deviceType}</strong>
        </div>
        <div>{}</div>
        <div>
          isMobile flag: <strong>{isMobile ? 'true' : 'false'}</strong>
        </div>
      </div>

      <div>
        <img
          src={imageUrl}
          alt='PocImage'
          // Optional: different sizing for desktop vs mobile
          style={
            isMobile
              ? { maxWidth: '100%', height: 'auto' } // mobile: fit screen width
              : { maxWidth: '800px', height: 'auto' } // desktop: "original" / larger sizing
          }
        />
      </div>

      {isMobile && (
        <div style={{ marginTop: '1rem' }}>
          <button onClick={openModal}>Open in Modal</button>

          <ImageModal
            isOpen={isModalOpen}
            src={imageUrl}
            onClose={closeModal}
          />
        </div>
      )}
    </div>
  );
}

export default PocImage2;
